<h6 class="heading-6">Overview</h6>
<p class="para6">{{employerDetails?.description}}</p>
<h6 class="heading-6">Company Size</h6>
<p>{{employerDetails?.companySize}} employees</p>
<h6 class="heading-6">Industry</h6>
<p>{{employerDetails?.industry}}</p>
<h6 class="heading-6">Company Detail</h6>
<div class="row ">
    <div class="col-sm-3 companydetail">
        <img src="assets/images/account.svg">
        <div class="content">
            <p>Primary contact</p>
            <h5>{{employerDetails?.name}}</h5>
        </div>
    </div>
    <div class="col-sm-3 companydetail">
        <img src="assets/images/ic_phone.svg">
        <div class="content">
            <p>Phone number</p>
            <h5>{{employerDetails?.phoneNumber}}</h5>
        </div>

    </div>
    <div class="col-sm-3 companydetail">
        <img src="assets/images/ic_email.svg">
        <div class="content">
            <p>Email</p>
            <h5>{{employerDetails?.email}}</h5>
        </div>
    </div>
    <div class="col-sm-3 companydetail">
        <img src="assets/images/linkedin.svg">
        <div class="content">
            <p>Linkedin</p>
            <a href="{{employerDetails?.linkedInLink}}" target="_blank">
                <h5>{{employerDetails?.linkedInLink}}</h5>
            </a>
        </div>
    </div>
</div>